module.exports = __webpack_public_path__ + "static/media/male.a247ae56.svg";